import { makeStyles } from '@material-ui/core';

// Golden Hippo monogram — shown in the collapsed sidebar. A gold rounded-square
// badge with "GH", drawn inline so there is no external asset/font dependency.
// Swap in the official brand vector here when available.
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const GOLD = '#edbf26';
const INK = '#0f1115';

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      role="img"
      aria-label="Golden Hippo"
    >
      <rect x="1" y="1" width="46" height="46" rx="11" fill={GOLD} />
      <text
        x="24"
        y="32"
        textAnchor="middle"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontSize="22"
        fontWeight="700"
        letterSpacing="0.5"
        fill={INK}
      >
        GH
      </text>
    </svg>
  );
};
